import { render } from "./TabItem.vue?vue&type=template&id=35725cd0&scoped=true"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"

import "./TabItem.vue?vue&type=style&index=0&id=35725cd0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35725cd0"]])

export default __exports__